// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from "./client";
import type {
  DeleteAccountDataData,
  PostAuthSendMagicLinkData,
  GetAuthVerifyMagicLinkData,
  GetAuthVerifyMagicLinkResponses,
  PostAuthVerifyMagicLinkData,
  PostAuthVerifyMagicLinkResponses,
  PostAuthVerifyTotpData,
  PostAuthVerifyTotpResponses,
  PostAuthAdminSendMagicLinkData,
  PostAuthAdminVerifyMagicLinkData,
  PostAuthAdminVerifyMagicLinkResponses,
  PostAuthTrusteeSendLinkData,
  PostAuthTrusteeVerifyLinkData,
  PostAuthTrusteeVerifyLinkResponses,
  GetAuthMeData,
  GetAuthMeResponses,
  PostAuthRevokeSessionsData,
  PostVaultAuthRequestData,
  PostVaultAuthVerifyData,
  PostVaultAuthVerifyResponses,
  PostVaultProfileNameData,
  PostClientCreateData,
  PostClientCreateResponses,
  GetClientGetData,
  GetClientGetResponses,
  GetClientListData,
  GetClientListResponses,
  PostClientUpdateData,
  DeleteClientDeleteData,
  PostClientResetVaultData,
  PostClientCheckOwnershipData,
  PostClientCheckOwnershipResponses,
  GetClientByClientIdVaultDetailsData,
  GetClientByClientIdVaultDetailsResponses,
  PostClientAccessGrantData,
  PostClientAccessRevokeData,
  GetClientAccessListData,
  GetClientAccessListResponses,
  PostClientByClientIdAttestationData,
  PostClientByClientIdAttestationResponses,
  PostClientAuthRegisterStartData,
  PostClientAuthRegisterStartResponses,
  PostClientAuthRegisterFinishData,
  PostClientAuthRegisterFinishResponses,
  PostClientAuthLoginStartData,
  PostClientAuthLoginStartResponses,
  PostClientAuthLoginFinishData,
  PostClientAuthLoginFinishResponses,
  PostClientAuthLogoutData,
  PostClientAuthLogoutAllData,
  PostPasskeysRegisterStartData,
  PostPasskeysRegisterStartResponses,
  PostPasskeysRegisterFinishData,
  DeletePasskeysByCredentialIdData,
  GetPasskeysData,
  GetPasskeysResponses,
  PostAuthPasskeyLoginStartData,
  PostAuthPasskeyLoginStartResponses,
  PostAuthPasskeyLoginFinishData,
  PostAuthPasskeyLoginFinishResponses,
  PostFilesInitiateData,
  PostFilesInitiateResponses,
  GetFilesByFileIdDownloadData,
  GetFilesListData,
  GetFilesListResponses,
  DeleteFilesByFileIdData,
  PostFilesByFileIdUploadData,
  PostFilesByFileIdUploadResponses,
  PostIdentityVerifyStartData,
  PostIdentityVerifyStartResponses,
  GetIdentityVerifyStatusData,
  GetIdentityVerifyStatusResponses,
  GetSharesByTrusteeByTrusteeIdentifierData,
  GetSharesByTrusteeByTrusteeIdentifierResponses,
  PutSharesByShareIdExecutorData,
  PutSharesByShareIdExecutorResponses,
  DeleteSharesByShareIdData,
  PostSharesData,
  PostSharesResponses,
  PostRecoveryStartData,
  PostRecoveryStartResponses,
  PostRecoveryResetPasswordData,
  PostRecoveryResetPasswordResponses,
  GetRecoveryMyVaultsData,
  GetRecoveryMyVaultsResponses,
  PostRecoveryResetVaultData,
  PostRecoveryResetVaultResponses,
  GetOrgListData,
  GetOrgListResponses,
  PatchOrgNameData,
  GetOrgMembersData,
  GetOrgMembersResponses,
  PostOrgMembersLeaveData,
  DeleteOrgMembersByUserIdData,
  GetOrgMembersByUserIdData,
  GetOrgMembersByUserIdResponses,
  PatchOrgMembersByUserIdRoleData,
  PatchOrgMembersByUserIdRoleResponses,
  GetOrgInvitesData,
  GetOrgInvitesResponses,
  PostOrgInvitesData,
  PostOrgInvitesAcceptData,
  PostOrgInvitesAcceptResponses,
  DeleteOrgInvitesByInviteIdData,
  PostOrgInvitesByInviteIdAcceptData,
  PostOrgInvitesByInviteIdAcceptResponses,
  PostOrgInvitesByInviteIdRejectData,
  PostOrgInvitesByInviteIdResendData,
  PostOrgEscrowKeyData,
  PostOrgEscrowSetupData,
  PostOrgEscrowSessionStartData,
  PostOrgEscrowSessionStartResponses,
  PostOrgEscrowSessionBySessionIdSubmitShardData,
  PostOrgEscrowSessionBySessionIdSubmitShardResponses,
  GetOrgEscrowSessionBySessionIdReconstructData,
  GetOrgEscrowSessionBySessionIdReconstructResponses,
  PostOrgMigrationInitiateData,
  PostOrgMigrationInitiateResponses,
  PostOrgMigrationExecuteData,
  PostOrgMigrationExecuteResponses,
  GetOrgBrandingData,
  GetOrgBrandingResponses,
  PatchOrgBrandingData,
  DeleteOrgData,
  PostOrgData,
  GetUnlockPetitionsPetitionDocKeyByClientIdData,
  GetUnlockPetitionsPetitionDocKeyByClientIdResponses,
  GetUnlockPetitionsByPetitionIdCertificateData,
  GetUnlockConfigData,
  GetUnlockConfigResponses,
  PostUnlockConfigData,
  GetUnlockAdviserKeyData,
  GetUnlockAdviserKeyResponses,
  PostUnlockStartData,
  PostUnlockStartResponses,
  GetUnlockBySessionIdData,
  GetUnlockBySessionIdResponses,
  PostUnlockBySessionIdPartialData,
  PostUnlockBySessionIdPartialResponses,
  GetUnlockBySessionIdPartialsData,
  GetUnlockBySessionIdPartialsResponses,
  PostUnlockBySessionIdCancelData,
  GetAdminFirmsData,
  GetAdminFirmsResponses,
  GetBrandingResolveData,
  GetBrandingResolveResponses,
  GetOrgInvitesPreviewByTokenData,
  GetOrgInvitesPreviewByTokenResponses,
  GetStripeCheckSubscriptionStatusData,
  GetStripeCheckSubscriptionStatusResponses,
  PostStripeCreateSubscriptionIntentData,
  PostStripeCreateSubscriptionIntentResponses,
  PostStripeConfirmSubscriptionData,
  PostStripeConfirmSubscriptionResponses,
  PostStripeCustomerPortalData,
  PostStripeCustomerPortalResponses,
  PostStripeCancelSubscriptionData,
  PostStripeCancelSubscriptionResponses,
  GetStripeInvoicesData,
  GetStripeInvoicesResponses,
  GetSupportThreadsData,
  GetSupportThreadsResponses,
  GetSupportThreadsByThreadIdData,
  GetSupportThreadsByThreadIdResponses,
  PostSupportThreadsByThreadIdCloseData,
  DeleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexData,
  DeleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexResponses,
  GetAdminSupportThreadsData,
  GetAdminSupportThreadsResponses,
  GetAdminSupportThreadsByThreadIdData,
  GetAdminSupportThreadsByThreadIdResponses,
  PostAdminSupportThreadsByThreadIdMessagesData,
  PostAdminSupportThreadsByThreadIdStatusData,
  DeleteAdminSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexData,
  DeleteAdminSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexResponses,
  GetUserInvitesData,
  GetUserInvitesResponses,
  PostUserRequestEmailChangeData,
  PostUserRequestEmailChangeResponses,
  PostUserConfirmEmailChangeData,
  PostUserConfirmEmailChangeResponses,
  GetUserTotpStatusData,
  GetUserTotpStatusResponses,
  PostUserSetupTotpData,
  PostUserSetupTotpResponses,
  PostUserConfirmTotpSetupData,
  PostUserDisableTotpData,
  GetUserData,
  GetUserResponses,
  PatchUserData,
  PatchUserResponses,
  GetHealthData,
  GetHealthResponses,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const deleteAccountData = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteAccountDataData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/account/data",
    ...options,
  });
};

export const postAuthSendMagicLink = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthSendMagicLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/auth/send-magic-link",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getAuthVerifyMagicLink = <ThrowOnError extends boolean = false>(
  options: Options<GetAuthVerifyMagicLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetAuthVerifyMagicLinkResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/verify-magic-link",
    ...options,
  });
};

export const postAuthVerifyMagicLink = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthVerifyMagicLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthVerifyMagicLinkResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/verify-magic-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postAuthVerifyTotp = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthVerifyTotpData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthVerifyTotpResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/verify-totp",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postAuthAdminSendMagicLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAuthAdminSendMagicLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/auth/admin/send-magic-link",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postAuthAdminVerifyMagicLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAuthAdminVerifyMagicLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthAdminVerifyMagicLinkResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/admin/verify-magic-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postAuthTrusteeSendLink = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthTrusteeSendLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/auth/trustee/send-link",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postAuthTrusteeVerifyLink = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthTrusteeVerifyLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthTrusteeVerifyLinkResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/trustee/verify-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getAuthMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthMeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAuthMeResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/me",
    ...options,
  });
};

export const postAuthRevokeSessions = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthRevokeSessionsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/auth/revoke-sessions",
    ...options,
  });
};

export const postVaultAuthRequest = <ThrowOnError extends boolean = false>(
  options: Options<PostVaultAuthRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/vault/auth/request",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postVaultAuthVerify = <ThrowOnError extends boolean = false>(
  options: Options<PostVaultAuthVerifyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostVaultAuthVerifyResponses,
    unknown,
    ThrowOnError
  >({
    url: "/vault/auth/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postVaultProfileName = <ThrowOnError extends boolean = false>(
  options: Options<PostVaultProfileNameData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/vault/profile/name",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postClientCreate = <ThrowOnError extends boolean = false>(
  options: Options<PostClientCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/create",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getClientGet = <ThrowOnError extends boolean = false>(
  options: Options<GetClientGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetClientGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/get",
    ...options,
  });
};

export const getClientList = <ThrowOnError extends boolean = false>(
  options?: Options<GetClientListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetClientListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/list",
    ...options,
  });
};

export const postClientUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PostClientUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/update",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const deleteClientDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteClientDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/client/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientResetVault = <ThrowOnError extends boolean = false>(
  options: Options<PostClientResetVaultData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/reset-vault",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postClientCheckOwnership = <ThrowOnError extends boolean = false>(
  options: Options<PostClientCheckOwnershipData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientCheckOwnershipResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/check-ownership",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getClientByClientIdVaultDetails = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetClientByClientIdVaultDetailsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetClientByClientIdVaultDetailsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/{client_id}/vault-details",
    ...options,
  });
};

export const postClientAccessGrant = <ThrowOnError extends boolean = false>(
  options: Options<PostClientAccessGrantData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/access/grant",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postClientAccessRevoke = <ThrowOnError extends boolean = false>(
  options: Options<PostClientAccessRevokeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/access/revoke",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getClientAccessList = <ThrowOnError extends boolean = false>(
  options?: Options<GetClientAccessListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetClientAccessListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/access/list",
    ...options,
  });
};

export const postClientByClientIdAttestation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostClientByClientIdAttestationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientByClientIdAttestationResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/{client_id}/attestation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientAuthRegisterStart = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostClientAuthRegisterStartData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientAuthRegisterStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/auth/register/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientAuthRegisterFinish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostClientAuthRegisterFinishData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientAuthRegisterFinishResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/auth/register/finish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientAuthLoginStart = <ThrowOnError extends boolean = false>(
  options: Options<PostClientAuthLoginStartData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientAuthLoginStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/auth/login/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientAuthLoginFinish = <ThrowOnError extends boolean = false>(
  options: Options<PostClientAuthLoginFinishData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientAuthLoginFinishResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/auth/login/finish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientAuthLogout = <ThrowOnError extends boolean = false>(
  options?: Options<PostClientAuthLogoutData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/client/auth/logout",
    ...options,
  });
};

export const postClientAuthLogoutAll = <ThrowOnError extends boolean = false>(
  options?: Options<PostClientAuthLogoutAllData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/client/auth/logout-all",
    ...options,
  });
};

export const postPasskeysRegisterStart = <ThrowOnError extends boolean = false>(
  options?: Options<PostPasskeysRegisterStartData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostPasskeysRegisterStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/passkeys/register/start",
    ...options,
  });
};

export const postPasskeysRegisterFinish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostPasskeysRegisterFinishData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/passkeys/register/finish",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const deletePasskeysByCredentialId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeletePasskeysByCredentialIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/passkeys/{credential_id}",
    ...options,
  });
};

export const getPasskeys = <ThrowOnError extends boolean = false>(
  options?: Options<GetPasskeysData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPasskeysResponses,
    unknown,
    ThrowOnError
  >({
    url: "/passkeys",
    ...options,
  });
};

export const postAuthPasskeyLoginStart = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthPasskeyLoginStartData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostAuthPasskeyLoginStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/passkey/login/start",
    ...options,
  });
};

export const postAuthPasskeyLoginFinish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAuthPasskeyLoginFinishData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthPasskeyLoginFinishResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/passkey/login/finish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postFilesInitiate = <ThrowOnError extends boolean = false>(
  options: Options<PostFilesInitiateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostFilesInitiateResponses,
    unknown,
    ThrowOnError
  >({
    url: "/files/initiate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getFilesByFileIdDownload = <ThrowOnError extends boolean = false>(
  options?: Options<GetFilesByFileIdDownloadData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: "/files/{file_id}/download",
      ...options,
    }
  );
};

export const getFilesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetFilesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetFilesListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/files/list",
    ...options,
  });
};

export const deleteFilesByFileId = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteFilesByFileIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/files/{file_id}",
    ...options,
  });
};

export const postFilesByFileIdUpload = <ThrowOnError extends boolean = false>(
  options: Options<PostFilesByFileIdUploadData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostFilesByFileIdUploadResponses,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    url: "/files/{file_id}/upload",
    ...options,
    headers: {
      "Content-Type": "application/octet-stream",
      ...options.headers,
    },
  });
};

export const postIdentityVerifyStart = <ThrowOnError extends boolean = false>(
  options: Options<PostIdentityVerifyStartData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostIdentityVerifyStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/identity/verify/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getIdentityVerifyStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetIdentityVerifyStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetIdentityVerifyStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/identity/verify/status",
    ...options,
  });
};

export const getSharesByTrusteeByTrusteeIdentifier = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSharesByTrusteeByTrusteeIdentifierData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSharesByTrusteeByTrusteeIdentifierResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shares/by-trustee/{trustee_identifier}",
    ...options,
  });
};

export const putSharesByShareIdExecutor = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PutSharesByShareIdExecutorData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).put<
    PutSharesByShareIdExecutorResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shares/{share_id}/executor",
    ...options,
  });
};

export const deleteSharesByShareId = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteSharesByShareIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/shares/{share_id}",
    ...options,
  });
};

export const postShares = <ThrowOnError extends boolean = false>(
  options: Options<PostSharesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostSharesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shares",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postRecoveryStart = <ThrowOnError extends boolean = false>(
  options?: Options<PostRecoveryStartData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostRecoveryStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/recovery/start",
    ...options,
  });
};

export const postRecoveryResetPassword = <ThrowOnError extends boolean = false>(
  options: Options<PostRecoveryResetPasswordData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostRecoveryResetPasswordResponses,
    unknown,
    ThrowOnError
  >({
    url: "/recovery/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getRecoveryMyVaults = <ThrowOnError extends boolean = false>(
  options?: Options<GetRecoveryMyVaultsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetRecoveryMyVaultsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/recovery/my-vaults",
    ...options,
  });
};

export const postRecoveryResetVault = <ThrowOnError extends boolean = false>(
  options: Options<PostRecoveryResetVaultData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostRecoveryResetVaultResponses,
    unknown,
    ThrowOnError
  >({
    url: "/recovery/reset-vault",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getOrgList = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/list",
    ...options,
  });
};

export const patchOrgName = <ThrowOnError extends boolean = false>(
  options: Options<PatchOrgNameData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/name",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getOrgMembers = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgMembersData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgMembersResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/members",
    ...options,
  });
};

export const postOrgMembersLeave = <ThrowOnError extends boolean = false>(
  options?: Options<PostOrgMembersLeaveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/members/leave",
    ...options,
  });
};

export const deleteOrgMembersByUserId = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteOrgMembersByUserIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/members/{user_id}",
    ...options,
  });
};

export const getOrgMembersByUserId = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgMembersByUserIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgMembersByUserIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/members/{user_id}",
    ...options,
  });
};

export const patchOrgMembersByUserIdRole = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchOrgMembersByUserIdRoleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchOrgMembersByUserIdRoleResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/members/{user_id}/role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getOrgInvites = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgInvitesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgInvitesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites",
    ...options,
  });
};

export const postOrgInvites = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgInvitesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/org/invites",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postOrgInvitesAccept = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgInvitesAcceptData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgInvitesAcceptResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/accept",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const deleteOrgInvitesByInviteId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteOrgInvitesByInviteIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/{invite_id}",
    ...options,
  });
};

export const postOrgInvitesByInviteIdAccept = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostOrgInvitesByInviteIdAcceptData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostOrgInvitesByInviteIdAcceptResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/{invite_id}/accept",
    ...options,
  });
};

export const postOrgInvitesByInviteIdReject = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostOrgInvitesByInviteIdRejectData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/{invite_id}/reject",
    ...options,
  });
};

export const postOrgInvitesByInviteIdResend = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostOrgInvitesByInviteIdResendData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/{invite_id}/resend",
    ...options,
  });
};

export const postOrgEscrowKey = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgEscrowKeyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/org/escrow-key",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postOrgEscrowSetup = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgEscrowSetupData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/org/escrow/setup",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postOrgEscrowSessionStart = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgEscrowSessionStartData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgEscrowSessionStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/escrow/session/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postOrgEscrowSessionBySessionIdSubmitShard = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostOrgEscrowSessionBySessionIdSubmitShardData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgEscrowSessionBySessionIdSubmitShardResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/escrow/session/{session_id}/submit-shard",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getOrgEscrowSessionBySessionIdReconstruct = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOrgEscrowSessionBySessionIdReconstructData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgEscrowSessionBySessionIdReconstructResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/escrow/session/{session_id}/reconstruct",
    ...options,
  });
};

export const postOrgMigrationInitiate = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgMigrationInitiateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgMigrationInitiateResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/migration/initiate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postOrgMigrationExecute = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgMigrationExecuteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgMigrationExecuteResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/migration/execute",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getOrgBranding = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgBrandingData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgBrandingResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/branding",
    ...options,
  });
};

export const patchOrgBranding = <ThrowOnError extends boolean = false>(
  options: Options<PatchOrgBrandingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/branding",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const deleteOrg = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteOrgData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org",
    ...options,
  });
};

export const postOrg = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/org",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getUnlockPetitionsPetitionDocKeyByClientId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetUnlockPetitionsPetitionDocKeyByClientIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUnlockPetitionsPetitionDocKeyByClientIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/unlock-petitions/petition-doc-key/{client_id}",
    ...options,
  });
};

export const getUnlockPetitionsByPetitionIdCertificate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUnlockPetitionsByPetitionIdCertificateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: "/unlock-petitions/{petition_id}/certificate",
      ...options,
    }
  );
};

export const getUnlockConfig = <ThrowOnError extends boolean = false>(
  options?: Options<GetUnlockConfigData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUnlockConfigResponses,
    unknown,
    ThrowOnError
  >({
    url: "/unlock/config",
    ...options,
  });
};

export const postUnlockConfig = <ThrowOnError extends boolean = false>(
  options: Options<PostUnlockConfigData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/unlock/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getUnlockAdviserKey = <ThrowOnError extends boolean = false>(
  options?: Options<GetUnlockAdviserKeyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUnlockAdviserKeyResponses,
    unknown,
    ThrowOnError
  >({
    url: "/unlock/adviser-key",
    ...options,
  });
};

export const postUnlockStart = <ThrowOnError extends boolean = false>(
  options: Options<PostUnlockStartData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostUnlockStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/unlock/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getUnlockBySessionId = <ThrowOnError extends boolean = false>(
  options?: Options<GetUnlockBySessionIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUnlockBySessionIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/unlock/{session_id}",
    ...options,
  });
};

export const postUnlockBySessionIdPartial = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUnlockBySessionIdPartialData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostUnlockBySessionIdPartialResponses,
    unknown,
    ThrowOnError
  >({
    url: "/unlock/{session_id}/partial",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getUnlockBySessionIdPartials = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUnlockBySessionIdPartialsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUnlockBySessionIdPartialsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/unlock/{session_id}/partials",
    ...options,
  });
};

export const postUnlockBySessionIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostUnlockBySessionIdCancelData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/unlock/{session_id}/cancel",
    ...options,
  });
};

export const getAdminFirms = <ThrowOnError extends boolean = false>(
  options?: Options<GetAdminFirmsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAdminFirmsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/admin/firms",
    ...options,
  });
};

export const getBrandingResolve = <ThrowOnError extends boolean = false>(
  options: Options<GetBrandingResolveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetBrandingResolveResponses,
    unknown,
    ThrowOnError
  >({
    url: "/branding/resolve",
    ...options,
  });
};

export const getOrgInvitesPreviewByToken = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOrgInvitesPreviewByTokenData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgInvitesPreviewByTokenResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/preview/{token}",
    ...options,
  });
};

export const getStripeCheckSubscriptionStatus = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetStripeCheckSubscriptionStatusData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetStripeCheckSubscriptionStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/check-subscription-status",
    ...options,
  });
};

export const postStripeCreateSubscriptionIntent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostStripeCreateSubscriptionIntentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostStripeCreateSubscriptionIntentResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/create-subscription-intent",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postStripeConfirmSubscription = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostStripeConfirmSubscriptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostStripeConfirmSubscriptionResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/confirm-subscription",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postStripeCustomerPortal = <ThrowOnError extends boolean = false>(
  options: Options<PostStripeCustomerPortalData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostStripeCustomerPortalResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/customer-portal",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postStripeCancelSubscription = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostStripeCancelSubscriptionData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostStripeCancelSubscriptionResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/cancel-subscription",
    ...options,
  });
};

export const getStripeInvoices = <ThrowOnError extends boolean = false>(
  options?: Options<GetStripeInvoicesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetStripeInvoicesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/invoices",
    ...options,
  });
};

export const getSupportThreads = <ThrowOnError extends boolean = false>(
  options?: Options<GetSupportThreadsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSupportThreadsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/support/threads",
    ...options,
  });
};

export const getSupportThreadsByThreadId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSupportThreadsByThreadIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSupportThreadsByThreadIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/support/threads/{thread_id}",
    ...options,
  });
};

export const postSupportThreadsByThreadIdClose = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostSupportThreadsByThreadIdCloseData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/support/threads/{thread_id}/close",
    ...options,
  });
};

export const deleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndex =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      DeleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).delete<
      DeleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexResponses,
      unknown,
      ThrowOnError
    >({
      url: "/support/threads/{thread_id}/messages/{message_id}/attachments/{index}",
      ...options,
    });
  };

export const getAdminSupportThreads = <ThrowOnError extends boolean = false>(
  options?: Options<GetAdminSupportThreadsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAdminSupportThreadsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/admin/support/threads",
    ...options,
  });
};

export const getAdminSupportThreadsByThreadId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAdminSupportThreadsByThreadIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAdminSupportThreadsByThreadIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/admin/support/threads/{thread_id}",
    ...options,
  });
};

export const postAdminSupportThreadsByThreadIdMessages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportThreadsByThreadIdMessagesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/admin/support/threads/{thread_id}/messages",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postAdminSupportThreadsByThreadIdStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportThreadsByThreadIdStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/admin/support/threads/{thread_id}/status",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const deleteAdminSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndex =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      DeleteAdminSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).delete<
      DeleteAdminSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexResponses,
      unknown,
      ThrowOnError
    >({
      url: "/admin/support/threads/{thread_id}/messages/{message_id}/attachments/{index}",
      ...options,
    });
  };

export const getUserInvites = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserInvitesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserInvitesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/invites",
    ...options,
  });
};

export const postUserRequestEmailChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserRequestEmailChangeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostUserRequestEmailChangeResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/request-email-change",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postUserConfirmEmailChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserConfirmEmailChangeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostUserConfirmEmailChangeResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/confirm-email-change",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getUserTotpStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserTotpStatusData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserTotpStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/totp-status",
    ...options,
  });
};

export const postUserSetupTotp = <ThrowOnError extends boolean = false>(
  options?: Options<PostUserSetupTotpData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostUserSetupTotpResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/setup-totp",
    ...options,
  });
};

export const postUserConfirmTotpSetup = <ThrowOnError extends boolean = false>(
  options: Options<PostUserConfirmTotpSetupData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/user/confirm-totp-setup",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postUserDisableTotp = <ThrowOnError extends boolean = false>(
  options: Options<PostUserDisableTotpData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/user/disable-totp",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user",
    ...options,
  });
};

export const patchUser = <ThrowOnError extends boolean = false>(
  options: Options<PatchUserData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchUserResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetHealthResponses,
    unknown,
    ThrowOnError
  >({
    url: "/health",
    ...options,
  });
};
